import { FC, useEffect, useState } from "react";
import { Button, Form, message, DatePicker, Select, Image, Input} from "antd";
import { useNavigate } from "react-router-dom";
import Card from "antd/es/card/Card";
import { ReservationAdminRequest } from "../../shared/types/request/reservationAdmin.model";
import { useAdminReservation } from "../../shared/services/planning/planning.service";
import { useGetRoles } from "../../shared/services/utilisateurs/user.service";
import "../../shared/style/antd-scrollliste.css";

const { RangePicker } = DatePicker;

const ReservationAdmin : FC = () => {

    useEffect(() => {
        const handler = (e : any) => {
            if (e.target.closest(".no-page-scroll-select")) {
                e.stopPropagation();
            }
        };

        document.addEventListener("wheel", handler, { passive: false });

        return () => document.removeEventListener("wheel", handler);
    }, []);

    const navigate = useNavigate()

    const[isAdmin, setIsAdmin] = useState<boolean | null>(null);
    const {dataRole, errorRole} = useGetRoles();

    useEffect(() => {
        if(errorRole){
            navigate("/connexion");
        }
    }, [errorRole]);

    useEffect(() =>{
        if(dataRole){
            setIsAdmin(dataRole.some(r => r.role === "ADMIN"));
        }
    }, [dataRole]);

    useEffect(() =>{
        if(isAdmin === false){
            retourEspaceUser();
        }
    }, [isAdmin]);


    function retourEspaceUser() {
        navigate("/espaceuser")
    }

    const [formValues, setFormValues] = useState<ReservationAdminRequest>();

    const {data, isLoading, error} = useAdminReservation(formValues);

    const onFinish = (values: any) => {
        const [start, end] = values.reservation;

        const request: ReservationAdminRequest = {
            username: localStorage.getItem('username') || "",
            dateDebut: start.format("DD/MM/YYYY"),
            dateFin: end.format("DD/MM/YYYY"),
            heureDebut: start.format("HH:mm:ss"),
            heureFin: end.format("HH:mm:ss"),
            numPoste: values.numPostes,
            nomEvenement: values.nomEvenement
        };
        setFormValues(request);
    };

    const[messageApi, contextHolder] = message.useMessage();

    useEffect(() =>{
        if(error && error.response.data){
            Object.values(error.response.data).forEach((msg) => {
                messageApi.error(msg as String);
            })
            
        }else{
            if(error)
            {
                messageApi.error("Une erreur est survenue : " + error.message);
            }
        }
    }, [error])

    useEffect(() => {
        if(data && data.ok){
            messageApi.success(data.ok);
        }
    }, [data])

    const options = Array.from({ length: 23 }, (_, i) => ({
        value: i + 1,
        label: <span>Poste {i + 1}</span>,
    }));

    return(
        <div>
            <Card title={<span style={{ textAlign: "center" }}>Réservation de votre événement</span>} variant="borderless" className="responsive-card">
                {contextHolder}
                <Form layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        label="Date de réservation"
                        name="reservation"
                        rules={[{required: true, message: "Les dates sont requis"}]}
                    >
                        <RangePicker format={"DD/MM/YYYY HH:mm:ss"} showTime />
                    </Form.Item>
                    <Form.Item
                        label="Numéro de poste"
                        name="numPostes"
                        rules={[{required: true, message: "Le numéro de poste est requis"}]}
                    >
                        <Select style={{width: "60%"}}
                            mode="multiple"
                            options={options}
                            classNames={{
                            popup: {
                            root: "no-page-scroll-select"
                            }
                        }} />
                    </Form.Item>
                    <Form.Item
                        label="Nom de l'événement"
                        name="nomEvenement"
                        rules={[{required: true, message: "Le nom de l'événement est requis"}]}
                    >
                        <Input style={{width: "60%"}} placeholder="Nom événement" />
                    </Form.Item>
                        <Button type="primary" loading={isLoading} htmlType="submit">
                            Réserver
                        </Button>
                </Form>
                <Button onClick={retourEspaceUser} style={{ marginTop: "24px" }}>Retour</Button>
            </Card>
            <div style={{ textAlign: "center" }}>
                 <Image
                    style={{ maxWidth: "100%", height: "auto" }}
                    src={`${process.env.PUBLIC_URL}/PlanPeche.jpg`}
                />
            </div>
        </div>
    )
}

export default ReservationAdmin;